module.exports = __webpack_public_path__ + "static/img/about-img-02.be3a79b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-img-02.jpg
// module id = /gZD
// module chunks = 0